/**
 * Mirrors the `_isVisible` walk in
 * `tsicommon/templates/tsicommon/templatetags/push_to_datalayer.html`: a
 * tracking element is considered visible when neither it nor any ancestor is
 * `display: none`. This is used to gate GA4 impression events
 * (`view_promotion` / `view_item_list`) so that blocks hidden via
 * `responsive_visibility` (or any other CSS-driven hide) do not inflate
 * analytics.
 *
 * Prefers the native `Element.checkVisibility()` API when available; falls back
 * to a `getComputedStyle().display` ancestor walk otherwise. A null element is
 * treated as visible (matches the legacy tag, which only suppresses when an
 * element is actively hidden).
 */
export const isElementVisible = (el: HTMLElement | null): boolean => {
    if (!el) {
        return true;
    }
    const elWithCheck = el as HTMLElement & {
        checkVisibility?: () => boolean;
    };
    if (typeof elWithCheck.checkVisibility === "function") {
        return elWithCheck.checkVisibility();
    }
    let current: HTMLElement | null = el;
    const root = el.ownerDocument.documentElement;
    while (current && current !== root) {
        if (getComputedStyle(current).display === "none") {
            return false;
        }
        current = current.parentElement;
    }
    return true;
};
